export const viewsKeys = {
  all: ['locales'] as const
};
